module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<iframe id="site" src="' +
__e( siteUrl ) +
'" sandbox="allow-forms allow-scripts allow-same-origin';
 if (browser.type.ie) { ;
__p += ' ms-allow-popups';
 } ;
__p += '" style="width: 100%; height: 100%; padding-right: 370px;"></iframe>\n<iframe id="toolbar" src="' +
__e( toolbarUrl ) +
'" style="width: 370px; height:100%; position: absolute; right: 0;" width="370px" height="100%"></iframe>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/publish/FramedPublishToolbarView.tpl
// module id = 3146
// module chunks = 0